import { debounce, TextField } from "@mui/material";
import {
  GridFilterInputValueProps,
  GridFilterOperator,
  GridFilterItem,
} from "@mui/x-data-grid";
import React from "react";

function CustomFilterInputValue(props: GridFilterInputValueProps) {
  const { item, applyValue } = props;
  const customFilterRef: React.Ref<any> = React.useRef(null);
  const [inputValue, setInputValue] = React.useState(item.value || 0);

  const handleSearchTextChange = React.useCallback(
    debounce((newValue: string) => {
      applyValue({ ...item, value: newValue });
    }, 1000),
    [applyValue, item]
  );

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setInputValue(newValue);
    handleSearchTextChange(newValue);
  };

  React.useEffect(() => {
    setInputValue(item.value || "");
  }, [item.value]);
  return (
    <TextField
      name="mfrFilterValue"
      onChange={handleInputChange}
      ref={customFilterRef}
      size="small"
      value={inputValue}
      variant="standard"
      label="Value"
      type="number"
      sx={{ pt: 0.4 }}
    ></TextField>
  );
}
export const customPriceFilterOperators: GridFilterOperator[] = [
  {
    label: "Equals",
    value: "equals",
    getApplyFilterFn: (filterItem: GridFilterItem) => {
      if (
        !filterItem.columnField ||
        !filterItem.value ||
        !filterItem.operatorValue
      ) {
        return null;
      }

      return (params): boolean => {
        return params.value == filterItem.value;
      };
    },
    InputComponent: CustomFilterInputValue,
  },
  {
    label: "Less than",
    value: "lessThan",
    getApplyFilterFn: (filterItem: GridFilterItem) => {
      if (
        !filterItem.columnField ||
        !filterItem.value ||
        !filterItem.operatorValue
      ) {
        return null;
      }

      return (params): boolean => {
        return params.value == filterItem.value;
      };
    },
    InputComponent: CustomFilterInputValue,
  },
  {
    label: "Greater than",
    value: "greaterThan",
    getApplyFilterFn: (filterItem: GridFilterItem) => {
      if (
        !filterItem.columnField ||
        !filterItem.value ||
        !filterItem.operatorValue
      ) {
        return null;
      }

      return (params): boolean => {
        return params.value == filterItem.value;
      };
    },
    InputComponent: CustomFilterInputValue,
  },
];
